var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17339 4.70687C1.66669 5.7798 1.66669 7.31171 1.66669 10C1.66669 13.1248 1.66669 14.6872 2.46245 15.7824C2.71945 16.1362 3.03052 16.4472 3.38425 16.7042C4.47952 17.5 6.04191 17.5 9.16669 17.5H10.8334C13.9581 17.5 15.5205 17.5 16.6158 16.7042C16.9695 16.4472 17.2806 16.1362 17.5376 15.7824C18.3334 14.6872 18.3334 13.1248 18.3334 10C18.3334 7.29271 18.3334 5.75821 17.8158 4.68419M2.17339 4.70687C2.25566 4.53266 2.35129 4.37055 2.46245 4.21756C2.71945 3.86383 3.03052 3.55276 3.38425 3.29576C4.47952 2.5 6.04191 2.5 9.16669 2.5H10.8334C13.9581 2.5 15.5205 2.5 16.6158 3.29576C16.9695 3.55276 17.2806 3.86383 17.5376 4.21756C17.6439 4.3639 17.736 4.51857 17.8158 4.68419M2.17339 4.70687L2.50002 5L4.10746 6.60744C6.88524 9.38522 8.27413 10.7741 10 10.7741C11.7259 10.7741 13.1148 9.38522 15.8926 6.60745L17.5 5L17.8158 4.68419",
    stroke: "url(#paint0_linear_1_46)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_46",
    x1: 1.66669,
    y1: 10,
    x2: 18.3334,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.910adb7d2983612b863d4c9a94f74ea5.svg";
export { ForwardRef as ReactComponent };